import attempt from "lodash/attempt";
import { useEffect } from "react";

const getScripts = (sources: string[]) => {
	try {
		const scripts = sources.map(src => {
			const url = new URL(src);
			const script = document.createElement("script");
			script.src = url.href;
			script.async = true;

			document.head.appendChild(script);
			return script;
		});

		return () => {
			attempt(() => scripts.forEach(s => document.head.removeChild(s)));
		};
	} catch (e) {
		console.log(e);
	}
};

const useScripts = (sources: string[]) => {
	useEffect(() => getScripts(sources), [sources]);
};

export default useScripts;